<template>
    <div class="weightpush content-view">
        <h2 class="fs-24 text-center fc-theme">搜索权重推送</h2>
        <p class="subtitle text-center fs-14 fc-666">通过官方搜索推荐算法，首页搜索结果推送，将单品推送到指定用户的搜索首屏上，提高搜索关键词下商品的权重值</p>
        <top-price code="searchpush" ref="topPrice"></top-price>
        <div><push-top-menu /></div>
        <div class="flex padding-20">
            <div class="flex-1 fc-333">
                <p>手淘权重推送（<span class="fc-theme">通过大数据算法提高搜索推送</span>）：</p>
                <p style="font-size: 12px; color: #888;">生意参谋显示【手淘搜索】-【打标词搜索访问】</p>

                <div class="marginT-20">推送搜索词 <span class="marginL-10 fc-aaa">例如希望搜索词是裙子显瘦</span></div>
                <el-input class="marginT-5" v-model="form.tag" placeholder="请输入推送的搜索词"></el-input>
                <div class="marginT-10">推送的商品链接 <span class="marginL-10 fc-aaa">例如https://detail.tmall.com/item.htm?id=612793112045</span></div>
                <el-input class="marginT-5" v-model="form.url" placeholder="请输入推送的商品链接"></el-input>
                <div class="marginT-10">推送搜索旺旺 <span class="marginL-10 fc-aaa">例如：天道酬勤，马云</span></div>
                <el-input class="marginT-5" v-model="form.account" placeholder="请输入推送旺旺号，逗号隔开，目前最多一次推送10个旺旺"></el-input>
                <div class="marginT-10">
                    <span>下单</span>
                    <el-tooltip class="item" effect="dark" content="扫码下单直接显示打单路径下单的" placement="top-start">
                        <i class="el-icon-question" style="margin-left: 6px;"></i>
                    </el-tooltip>
                </div>
                <div>
                    <el-radio-group class="marginT-5" v-model="form.tag_type" @change="tagTypeChange">
                        <el-radio :label="1">需要搜索下单</el-radio>
                        <el-radio :label="2">不需要搜索下单</el-radio>
                    </el-radio-group>
                </div>
                <el-button class="marginT-20" type="danger" @click="onSubmit">开始推送</el-button>

                <p class="marginT-10 fc-theme">提示 : 推送关键词即可快速找到商品，推送成功显示在搜索结果页高达90%，推送失败不扣点券!  </p>
            </div>
            <div class="flex-1 right">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <el-tabs v-model="activeTip">
                            <el-tab-pane label="功能简介" name="first"></el-tab-pane>
                            <el-tab-pane label="功能用途" name="second"></el-tab-pane>
                            <el-tab-pane label="消费说明" name="third"></el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="fs-14" v-if="activeTip === 'first'">
                        <div class="content fc-666">
                            搜索权重推送原理是通过大数据分析判断该商品在该账号下是否有潜在成交可能性，通过数据算法提高商品在消费者搜索结果页，提升商品的曝光率。
                        </div>
                        <div class="content fc-666">
                            达到直通车效果却收费比直通车低，让商品推送到任意消费者搜索结果中，
                        </div>
                        <div class="content fc-666">
                            推送也不是100%全部成功，商品权重越高推送成功率越大，消费者也很难在首屏看到权重较低商品。有基础权重的商品推成功率较高，一旦显示推送成功，推送显示成功的概率高达90%，介意勿用该功能
                        </div>
                    </div>
                    <div class="fs-14" v-if="activeTip === 'second'">
                        <div class="content fc-666">1、配合店铺活动将活动商品推送到潜在购买的消费者搜索结果里去，增加商品的曝光率，提高交易额。</div>
                        <div class="content fc-666">2、配合第三方做单平台，在短词搜索结果中出现推送的商品</div>
                        <div class="content fc-666">3、推送给意向客户，之前有咨询没付款的，使用权重推送后，能将宝贝推送到他们的搜索页。</div>
                    </div>
                    <div class="fs-14" v-if="activeTip === 'third'">
                        <div class="content fc-666" v-if="$store.state.phone">1、非会员用户推送成功一次{{pricePreMonth.point}}点券，会员用户推送成功一次{{pricePreMonth.vip_point}}点券。</div>
                        <div class="content fc-666">2、推送失败不扣取任何点数，充值1元到账100点券。</div>
                        <div class="content fc-666">3、有很低概率1%商品推送成功但是搜索结果页前几名没有推送的商品。</div>
                        <div class="content fc-666">4、接口合作请加微信{{getkfWx()}}。</div>
                    </div>
                </el-card>
            </div>
        </div>
        <div class="query-record">
            <el-card class="box-card flex-1 marginT-20">
                <div slot="header" class="flex flex-between">
                    <span class="fw-bold fc-333">查询记录<span style="font-size: 12px; color: #f00; padding-left: 6px;">(查询记录数据仅保存90天)</span></span>
                </div>
                <div>
                    <div class="table">
                        <el-table :data="tableData" fit
                            :span-method="arraySpanMethod"
                            style="border: 1px solid #eee;">
                            <el-table-column prop="invoke_params.tag"
                                align="center" label="推送权重词">
                                <template slot-scope="scope">
                                    <div>
                                        <p v-if="scope.row.invoke_params.tag">{{scope.row.invoke_params.tag}}</p>
                                        <div v-if="scope.row.invoke_params.items && scope.row.invoke_params.items.length > 0"
                                            @click="openRecord(scope.row.invoke_params.items)"
                                            class="fc-blue point"
                                        >显示详细</div>
                                    </div>
                                </template>
                                </el-table-column>
                            <el-table-column width="180" label="推送商品ID">
                                <template slot-scope="scope">
                                    <el-popover trigger="hover" placement="top">
                                        <p>{{ scope.row.invoke_params.url.indexOf('http') > -1 ? getQueryVariable(scope.row.invoke_params.url) : scope.row.invoke_params.url }}</p>
                                        <div slot="reference"
                                            class="name-wrapper">
                                            {{ scope.row.invoke_params.url.indexOf('http') > -1 ? getQueryVariable(scope.row.invoke_params.url) : scope.row.invoke_params.url }}
                                        </div>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="invoke_params.account"
                                label="推送搜索旺旺号" align="center">
                                <template slot-scope="scope">
                                    <div>
                                        <p v-if="scope.row.invoke_params.account">{{scope.row.invoke_params.account}}</p>
                                        <div v-if="scope.row.invoke_params.items && scope.row.invoke_params.items.length > 0"
                                            @click="recordDialog.table = scope.row.invoke_params.items, recordDialog.show = true"
                                            class="fc-blue point"
                                        >显示详细</div>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column prop="created_at" label="提交时间">
                                <template
                                    slot-scope="scope">{{ (scope.row.invoke_time * 1000) | dateFormatUtils}}</template>
                            </el-table-column>
                            <el-table-column prop="search_account" label="完成时间">
                                <template
                                    slot-scope="scope">{{ (scope.row.invoke_time * 1000) | dateFormatUtils}}</template>
                            </el-table-column>
                            <el-table-column prop="status" align="center"
                                width="100" label="推送状态">
                                <template
                                    slot-scope="scope">{{ scope.row.result_code == 0 ? '成功' : '失败'}}</template>
                            </el-table-column>
                            <el-table-column prop="code" align="center"
                                label="记录备注">
                                <template slot-scope="scope">
                                    <el-popover trigger="hover" placement="top">
                                        <p>{{ scope.row.result_message ? (scope.row.result_message.replace('打标', '推送') || '--') : ""}}</p>
                                        <div slot="reference" class="name-wrapper">{{ scope.row.result_message ? (scope.row.result_message.replace('打标', '推送') || '--') : ""}}</div>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" width="100"
                                prop="money_type" label="消耗点数">
                                <template slot-scope="scope">{{scope.row.invoke_paid_point}}</template>
                            </el-table-column>
                            <el-table-column align="center" width="100" label="二维码">
                                <template slot-scope="scope">
                                    <img @click="tableQrCodeShow(scope.row)" style="cursor: pointer" width="30" height="30" :src="require('@/index/assets/img/qrcode_icon.png')" alt="">
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pages marginT-20 text-center">
                        <el-pagination @current-change="handleCurrentChange"
                            :current-page="page" :page-size="5"
                            layout="total, prev, pager, next, jumper"
                            :total="total"></el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
        <mark-record-details v-if="recordDialog.show" v-model="recordDialog.show" type="push" :table="recordDialog.table"></mark-record-details>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import mixin from '../../mixin/pagination'
import markRecordDetails from '../../components/_dialog/markRecordDetails';
import PushTopMenu from '../push/_components/PushTopMenu';
export default {
    computed: mapState(['userData', 'phone', 'configData']),
    mixins: [mixin],
    components: {
        markRecordDetails,
        PushTopMenu,
    },
    data() {
        return {
            activeTip: 'first',
            pricePreMonth: {},
            form: {
                tag: '',
                url: '',
                account: '',
                // tag_type: this.$store.state.userData.is_vip ? 1 : 2, // 1需要搜索下单 2不需要搜索下单
                tag_type:  2, // 1需要搜索下单 2不需要搜索下单
            },
            searchForm: {
                cate: 'tool',
                method: 'searchpush',
                psize: 5
            },
            recordDialog: {
                show: false,
                table: []
            },
            tableData: [],
            tableUrl: '/tool/accounts/api-record'
        }
    },
    methods: {
        tipForce() {
            // 确定不是在预渲染环境下
            if (!localStorage.compile) {
                this.$alert('系统维护中，暂时不稳定，建议可以使用关键词卡首屏', '重要通知', {
                    confirmButtonText: '确定',
                    showClose: false,
                    callback: action => {
                        this.$router.push('/checkNum/firstPause')
                    }
                })
            }
        },
        async priceLimit() {
            const data = await this.$fetch('/tool/apps/api-info', { name: 'searchpush' })
            this.pricePreMonth = data.data
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (row.invoke_params.items && row.invoke_params.items.length > 0) {
                if (columnIndex === 0) {
                    return [1, 3]
                } else if (columnIndex === 2 || columnIndex === 1) {
                    return [0, 0]
                }
            }
        },
        openRecord(item) {
            if (typeof(item) == 'string' && item.indexOf('[') > -1) {
                this.recordDialog.table = JSON.parse(item).map(i => {
                    return {...i, result_msg: '推送成功'}
                })
            } else {
                this.recordDialog.table = item
            }
            this.recordDialog.show = true
        },
        async onSubmit() {
            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }

            window.checkDiscountPackage("searchpush")

            if (!this.form.tag || !this.form.url || !this.form.account) {
                this.$message.error('请填写完整')
                return
            }
            if (this.form.url.indexOf('http') < 0) {
                this.$message.error('请填写正确网址')
                return
            }
            let list = []
            let listStr = this.form.account + ''
            listStr = listStr.replace(/，/g, ',')
            list = listStr.split(',')
            this.batchSubmit(list)
        },
        async batchSubmit(list) {
            let loading = this.$loading({
                lock: true,
                text: '提交中',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.5)'
            })

            let subData = []
            let formURL = this.form.url
            formURL = formURL.replace(/\s+/g, '')

            for (let i = 0; i < list.length; i++) {
                if (i == 800) {
                    break
                }
                const sheetData = {
                    task_sn: i,
                    account: list[i],
                    tag: this.form.tag,
                    url: this.getQueryVariable(new URL(formURL), 'id')
                }
                if (sheetData.account && sheetData.tag && sheetData.url) {
                    sheetData.account = sheetData.account.replace(/ /g, '')
                    sheetData.tag = sheetData.tag.replace(/ /g, '')
                    if (!sheetData.account || !sheetData.tag) {
                        continue
                    }
                } else {
                    continue
                }
                subData.push(sheetData)
            }

            const { code, data, msg, time } = await this.$fetch(
                '/api/proxy/web/searchpush',
                {
                    items: JSON.stringify(subData),
                    tag_type: this.form.tag_type,
                },
                'post'
            )
            loading.close()

            if (code == 0) {
                if (+this.form.tag_type === 1) {
                    // 如果需要搜索下单, 则先进行二维码弹框 然后正常处理打单请求
                    // 逻辑修改, 弹框必须在打单之后弹出来, 防止用户没钱二维码也正常弹出
                    if (+this.form.tag_type === 1) {
                        window.showPushQrCode({
                            url: this.getQueryVariable(new URL(formURL), 'id'),
                            tag: this.form.tag,
                            invoke_time: time,
                        })
                    }
                } else {
                    this.$message.success('提交成功')
                }
                this.$store.dispatch('upDateUser')
                this.init()
                setTimeout(() => {
                    this.$store.dispatch('upDateUser')
                    this.init()
                }, 5000)
            } else {
                this.$alert(`抱歉, 打标失败, ${msg}`, '温馨提示', {
                    confirmButtonText: '确定',
                    callback: action => {}
                });
            }

            this.$refs.topPrice.getPopup(true)
        },

        tagTypeChange(value) {
            if (!this.userData.is_vip && value === 1) {
                this.form.tag_type = 2;
                this.$message.warning("该选项仅对会员用户使用, 请先开通会员")
            }
        },

        tableQrCodeShow(row) {
            this.$message.warning("二维码不存在或已失效")
            // window.showQrCode(row.code_url)
        },

        fillData() {
            let accounts = this.$route.query.accounts;
            let item_id = this.$route.query.item_id;

            if (accounts) {
                let accountsArr = accounts.split(/\r?\n/)
                this.form.account = accountsArr.join(",")
            }
            if (item_id) {
                this.form.url = item_id;
            }
        }
    },
    mounted() {
        // this.tipForce()
        if (localStorage.token) {
            this.init()
            // this.priceLimit()
        }

        this.fillData()

        // 如果是会员则优先选择需要搜索下单
        if (this.$store.state.userData.is_vip) {
            this.form.tag_type = 1;
        }
    }
}
</script>

<style lang="scss" scoped>
.weightpush {
    .right {
        margin-left: 30px;
        .title {
            margin-top: 5px;
        }
    }
}
</style>
<style lang="scss">
.weightpush {
    .el-card__header {
        padding-bottom: 0;
    }
    .el-tabs__header {
        margin-bottom: 0;
    }
    .el-tabs__nav-wrap::after {
        height: 0;
    }
    .el-card__body {
        min-height: 333px;
    }
}
</style>
